import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import assets from 'modules/assets'
import RowThreeBlock from 'components/Utils/RowThreeBlock'

class GetInvolvedRows extends Component {
  constructor(props) {
    super(props)
    this.state = { ...props }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  render() {
    return (
      <section className="main-grid center">
        <ul className="grid group">
          <li className="grid-small">
            <h3>Get Involved.</h3>
          </li>

          <li className="grid-small grid-middle">
            <h2>Gakko New York applications are open!</h2>
            <h5 className="grid-link">
              <Link className='link' to={'newyork'}>Click here to learn more >></Link>
            </h5>
          </li>

          <li className="grid-small">
            <h2>Gakko Digital Learning is hiring a product manager!</h2>
            <h5 className="grid-link">
              <Link className="link" to={'digital#apply'}>Click here to learn more >></Link>
            </h5>
          </li>
        </ul>

        <RowThreeBlock data={this.props.data} />
      </section>
    )
  }
}
GetInvolvedRows.contextTypes = {
}
GetInvolvedRows.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(GetInvolvedRows)



// WEBPACK FOOTER //
// ./src/components/Utils/GetInvolvedRows.js